import { parseString } from "xml2js";
import { diosmAepsDailyLogin, addherPayWithdrawal, diosmGetMerchantDetail,  getCheckDiosmLoginStatus } from "../../utils/api";



const initialControls = {
	transactionType: 'Withdrawal',
	aadharNumber: '',
	amount: '',
	bank: '',
	mobileNumber: '',
};

let ckeckLogin = false;

export const diosmMerchantDetail = (setLoading,setAepsStatus,setAlert,position) => {
    setLoading(true);
    const params = {
        latitude:position?.latitude,
	    longitude:position?.longitude
    }
    diosmGetMerchantDetail(params).then((resp) => {
        setLoading(false);
        if (resp?.success) {
            if (resp?.data) {
                
                checkDiosmLoginStatus(setLoading,setAepsStatus,setAlert);
              
            } else {
                setAlert({ type: 'warning', msg: 'Please complete your kyc with aeps', });
            }
        } else {
            if (resp?.errorCodeList.length > 0) {
                if(resp?.errorCodeList[0] === "Please contact admin."){
                    setAlert({ type: 'error', msg: resp?.errorCodeList[0], });
                    return;
                }
                setAlert({ type: 'warning', msg: 'Please complete your kyc with aeps', });
              
            } else {
                setAlert({ type: 'error', msg: resp?.msg,  });
            }
        }
    });
};


const checkDiosmLoginStatus = (setLoading,setAepsStatus,setAlert) => {
    setLoading(true);

    getCheckDiosmLoginStatus("AADHAAR_PAY").then((resp) => {
        setLoading(false);
        if (resp?.success) {
            setAepsStatus("yes");
            
        } else {
            setLoading(false);
            
            setAepsStatus('selectDevice');
            ckeckLogin = true;
            if (resp?.errorCodeList.length > 0) {
                setAlert({ type: 'error', msg: resp?.errorCodeList[0],  });
                
            } else {
                setAlert({ type: 'error', msg: resp?.msg,  });
            }
        }
    });
};

function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
}



export const diosmDailyLogin = (setLoading,setAepsStatus,setAlert,fingerPrirntData ,deviceType,controls) => {
 
    setLoading(true);
    const param = {
        merchantId: '',
        pid_xml_base64e: fingerPrirntData,
        serviceType:"AADHAAR_PAY"
    };
    diosmAepsDailyLogin(param).then((resp) => {
        setLoading(false);
        if (resp?.success) {
            localStorage.setItem("deviceType",deviceType);
            if((controls.transactionType ==="Withdrawal") && !ckeckLogin){
                setAepsStatus('verifyCustomer');
            }else{
                setAepsStatus('yes');
                ckeckLogin = false;
            }
            
            setAlert({ type: 'success', msg: 'Login successful. Please scan customer fingerprint', });
        } else {
            if (resp?.errorCodeList.length > 0) {
                setAlert({ type: 'error', msg: resp?.errorCodeList[0],  });
            } else {
                setAlert({ type: 'error', msg: resp?.msg, });
            }
        }
    });
};




let testMantraPort = 1;
export function DiosmCapture(param, type,deviceType,aepsStatus,setBankDataResp,overLayers,setOverLayer,setControls,setFingerprintLoader,controls,setAepsStatus,setAlert,setLoading) {
    var url = '';
    var PIDOPTS = '';
    setLoading(true);
    if (deviceType === 'Morpho') {
        if(aepsStatus ==="verifyFingerPrint"){
            
            PIDOPTS =
            '<PidOptions ver="1.0">' +
            '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" posh=""/>' +
            '</PidOptions>';
        }else{
        PIDOPTS =
            '<PidOptions ver="1.0">' +
            '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="" posh=""/>' +
            '</PidOptions>';
        }
       
        if (testMantraPort === 1){
           
            url = 'http://127.0.0.1:11100/capture';
        }else{
            url = 'https://127.0.0.1:11100/capture';
        }
    } else if (deviceType === 'Mantra') {
        if(aepsStatus ==="verifyFingerPrint"){
            PIDOPTS =
            '<PidOptions ver="1.0"> '+
            '<Opts fCount="1" fType="2" iCount="0" pCount="0" pgCount="1" format="0"   pidVer="2.0" timeout="10000"  wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" posh="" env="P" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts>'+
            '</PidOptions>';
        }else{
                
                 PIDOPTS =
                 '<PidOptions ver="1.0"> '+
                 '<Opts fCount="1" fType="2" iCount="0" pCount="0" pgCount="1" format="0"   pidVer="2.0" timeout="10000"  wadh="" posh="" env="P" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts>'+
                 '</PidOptions>';
        }

        const preUrl = localStorage.getItem('MantraRdUrll');
        if (preUrl) {
            url = preUrl;
        } else {
            if (testMantraPort === 1) {
                url = `https://127.0.0.1:11100/rd/capture`;
            } else if (testMantraPort === 2) {
                url = 'https://127.0.0.1:11101/rd/capture';
            } else if (testMantraPort === 3) {
                url = 'https://127.0.0.1:8005/rd/capture';
            }

        }
    } else if (deviceType === 'Tatvik') {
        url = 'https://127.0.0.1:11100/rd/capture';
    }
    

    var xhr;
    setFingerprintLoader(true);
    xhr = new XMLHttpRequest();
    xhr.open('CAPTURE', url, true);
    xhr.setRequestHeader('Content-Type', 'text/xml');
    xhr.setRequestHeader('Accept', 'text/xml');

    xhr.onreadystatechange = async function () {

        if (xhr.readyState === 4) {
            var status = xhr.status;

            if (status === 200) {
                var test1 = xhr.responseText;
                var test2 = test1.search('errCode');
                var test6 = getPosition(test1, '"', 2);
                var test4 = test2 + 9;
                var test5 = test1.slice(test4, test6);

                const fingerPrirntData = await Buffer.from(xhr.responseText).toString('base64');
                convertXmlToJs(xhr.responseText).then((result) =>{ 
                    setFingerprintLoader(false);
                    const error =	result?.PidData?.Resp[0].$;
                    setFingerprintLoader(false);
                    if (deviceType === 'Mantra') {
                        if (testMantraPort === 1) {
                            const url = `https://127.0.0.1:11100/rd/capture`;
                            localStorage.setItem('MantraRdUrl', url);
                        } else if (testMantraPort === 2) {
                            const url = 'https://127.0.0.1:11101/rd/capture';
                            localStorage.setItem('MantraRdUrl', url);
                        } else if (testMantraPort === 3) {
                            const url = 'https://127.0.0.1:8005/rd/capture';
                            localStorage.setItem('MantraRdUrl', url);
                        }
                    }
                    if(Number(error.errCode) != 0){
                        setLoading(false);
                        setAlert({ type: 'error', msg: error.errInfo });
                        return;
                    }else{
                        setAlert({ type: 'success', msg: 'FingerPrint Captured Successfully' });
                        setLoading(false);
                        param.pid_xml_base64e = fingerPrirntData;
                        if (type === 'customer') {
                            if (controls.transactionType === 'Withdrawal') {
                                setLoading(true);
                                addherPayWithdrawal(param).then((res) => {
                                    setLoading(false);
                                     if (res?.data) {
                                        setControls({ ...initialControls });
                                        setOverLayer(true);
                                        overLayers(true);
                                        setBankDataResp(res.data);
                                    } else {
                                        setOverLayer(false);
                                        setAepsStatus("yes");
                                        setControls({ ...initialControls });
                                        if (res?.errorCodeList.length > 0) {
                                            setAlert({ type: 'error', msg: res?.errorCodeList[0],  });
                                        } else {
                                            setAlert({ type: 'error', msg: res?.msg,  });
                                        }
                                    }
                                });
                            }
                         
                        } else  {
                            setLoading(false);
                            diosmDailyLogin(setLoading,setAepsStatus,setAlert,fingerPrirntData,deviceType,controls);
                        }
                         
                       
                     
                    }
                })
                
               
            } else {
                setLoading(false);
                setFingerprintLoader(false);
            }
        }
    };

    xhr.onerror = function () {
        if (deviceType === 'Mantra') {
            setLoading(false);
            if (testMantraPort < 3) {
                testMantraPort = testMantraPort + 1;
                DiosmCapture(param, type,deviceType,aepsStatus,setBankDataResp,overLayers,setOverLayer,setControls,setFingerprintLoader,controls,setAepsStatus,setAlert,setLoading)
            }
        }
        if (deviceType === 'Morpho') {
            setLoading(false);
            if (testMantraPort < 2) {
                testMantraPort = testMantraPort + 1;
                DiosmCapture(param, type,deviceType,aepsStatus,setBankDataResp,overLayers,setOverLayer,setControls,setFingerprintLoader,controls,setAepsStatus,setAlert,setLoading)
            }
        } 

    };
    xhr.send(PIDOPTS);
}

function convertXmlToJs(xmlData) {
    return new Promise((resolve, reject) => {
        parseString(xmlData, (err, result) => {
            if (err) {
                reject(err);
            } else {
                resolve(result);
            }
        });
    });
}